import { render } from "./ImprovedStatsTile.vue?vue&type=template&id=3ac2542b&scoped=true"
import script from "./ImprovedStatsTile.vue?vue&type=script&lang=js"
export * from "./ImprovedStatsTile.vue?vue&type=script&lang=js"

import "./ImprovedStatsTile.vue?vue&type=style&index=0&id=3ac2542b&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac2542b"]])

export default __exports__